import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import PrivacyPolice from '../views/PrivacyPolice.vue'
import TermsAndConditions from '../views/TermsAndConditions.vue'
import DeleteAccount from '@/views/deleteAccount.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/Privacy-Police',
    name: 'PrivacyPolice',
    component: PrivacyPolice
  },
  {
    path: '/terms-And-Conditions',
    name: 'TermsAndConditions',
    component: TermsAndConditions
  },
  {
    path: '/delete-data',
    name: 'deletData',
    component: DeleteAccount
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
